// React
import { useEffect, useState } from 'react';
// Components
import { Banner, TextLoading } from '@components/';
// Routes
import { Router } from '@routes/';
// Style
import { ThemeProvider } from 'styled-components';
import { DEFAULT_THEME } from '@zendeskgarden/react-theming';
// Services
import { initializeApi, popupError } from '@services/';
// Contexts
import { TokenContextProvider } from '@contexts/';

export default function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await initializeApi();
        setInitialized(true);
      } catch (err) {
        console.error('Erro ao inicializar API', err);
        popupError('Erro ao inicializar API', false);
      }
    })();
  }, []);

  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-lg">
          <TextLoading texts={['Carregando...', 'Iniciando app zendesk...']} />
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider theme={DEFAULT_THEME}>
      <TokenContextProvider>
        <Banner />
        <Router />
      </TokenContextProvider>
    </ThemeProvider>
  );
}
